import React from 'react'
import { Column } from 'src/components/Layout/Styled'
import { Typography } from '@mui/material'
import Summary from './Summary'
import ExaminerInfo from './ExaminerInfo'

const Confirmation = () => {
  return (
    <Column>
      <Typography variant="h6" sx={{ mb: 4 }}>
        ยืนยันข้อมูลการสมัครสอบ
      </Typography>
      <Summary />
      <ExaminerInfo />
    </Column>
  )
}

export default Confirmation
